// DOM port of T3 Code's ComposerControl, ModelPickerContent/Sidebar/Row and TraitsPicker.
const labels = {
  off: "Off",
  minimal: "Minimal",
  low: "Low",
  medium: "Medium",
  high: "High",
  xhigh: "Extra high",
  max: "Maximum",
  default: "Normal",
  priority: "Fast",
};
const paths = {
  chevron: ["m6 9 6 6 6-6"],
  check: ["m20 6-11 11-5-5"],
  search: ["m21 21-4.34-4.34", "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16"],
  star: [
    "m12 3 2.78 5.63L21 9.54l-4.5 4.39 1.06 6.2L12 17.2l-5.56 2.93 1.06-6.2L3 9.54l6.22-.91L12 3Z",
  ],
  brain: [
    "M12 18V5",
    "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4",
    "M17.6 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.6 1.5",
    "M17.997 5.125a4 4 0 0 1 2.526 5.77",
    "M18 18a4 4 0 0 0 2-7.464",
    "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517",
    "M6 18a4 4 0 0 1-2-7.464",
    "M6.003 5.125a4 4 0 0 0-2.526 5.77",
  ],
  codex: [
    "M252.794 108.802C289.191 99.0484 326.265 110.305 351.148 135.135C385.113 126.072 422.85 134.862 449.492 161.505C476.136 188.149 484.925 225.888 475.862 259.85V259.854C500.696 284.735 511.95 321.81 502.198 358.207C492.447 394.602 464.161 421.084 430.215 430.217C421.083 464.162 394.603 492.448 358.206 502.199C321.812 511.951 284.734 500.693 259.852 475.864C225.887 484.927 188.15 476.137 161.507 449.495C134.864 422.851 126.073 385.111 135.136 351.149C110.304 326.266 99.0496 289.192 108.801 252.795C118.552 216.4 146.84 189.918 180.784 180.785C189.917 146.841 216.396 118.553 252.794 108.802ZM374.292 407.145C374.292 411.271 372.092 415.086 368.517 417.148L283.723 466.102C302.487 480.585 327.555 486.459 352.217 479.852C386.997 470.532 410.068 439.312 410.555 405.006V317.717C410.555 315.08 409.125 312.621 406.843 311.303L374.292 292.509V407.145ZM251.868 415.897C248.296 417.959 243.893 417.959 240.317 415.897L155.526 366.942C152.366 390.436 159.811 415.08 177.866 433.136H177.863C203.325 458.594 241.896 462.962 271.85 446.232L347.449 402.586C349.735 401.268 351.148 398.8 351.148 396.163V358.579L251.868 415.897ZM368.602 220.628C366.319 219.309 363.474 219.318 361.191 220.637L328.641 239.431L427.921 296.749C431.496 298.811 433.697 302.627 433.697 306.752V404.661C455.622 395.654 473.244 376.881 479.851 352.218C489.169 317.442 473.668 281.85 444.201 264.274L368.602 220.628ZM177.303 206.34C155.377 215.348 137.756 234.122 131.148 258.783C121.832 293.561 137.331 329.153 166.799 346.727L242.398 390.373C244.68 391.692 247.525 391.684 249.807 390.366L282.357 371.572L183.078 314.253C179.504 312.189 177.303 308.375 177.303 304.251V206.34ZM259.849 279.145V331.858L305.5 358.213L351.15 331.858V279.145L305.5 252.789L259.849 279.145ZM327.276 144.9C308.512 130.418 283.445 124.543 258.782 131.15C224.002 140.471 200.931 171.691 200.445 205.995V293.286C200.445 295.923 201.875 298.381 204.158 299.7L236.707 318.493V203.856C236.707 199.731 238.909 195.916 242.483 193.853L327.276 144.9ZM433.137 177.867C407.675 152.407 369.103 148.038 339.149 164.769L263.55 208.415C261.265 209.734 259.852 212.202 259.852 214.838V252.423L359.132 195.105C362.703 193.041 367.108 193.041 370.682 195.105L455.473 244.06C458.635 220.567 451.189 195.922 433.135 177.867H433.137Z",
  ],
};
function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text) node.textContent = text;
  return node;
}
function icon(name) {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute(
    "viewBox",
    name === "codex" ? "100 100 411 411" : "0 0 24 24",
  );
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute(
    "class",
    `control-icon ${name === "chevron" ? "control-chevron" : ""}`,
  );
  svg.setAttribute("fill", name === "codex" ? "currentColor" : "none");
  svg.setAttribute("stroke", name === "codex" ? "none" : "currentColor");
  svg.setAttribute("stroke-width", name === "chevron" ? "2.25" : "2");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  for (const d of paths[name] || paths.brain) {
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", d);
    if (name === "codex") path.setAttribute("fill-rule", "evenodd");
    svg.append(path);
  }
  return svg;
}
function button(className, label, action) {
  const node = el("button", className);
  node.type = "button";
  node.setAttribute("aria-label", label);
  node.title = label;
  node.addEventListener("click", action);
  return node;
}
const modelKey = (model) => JSON.stringify([model.provider, model.modelId]);
const providerLabel = (provider) =>
  provider === "openai-codex" ? "Codex" : provider;
const providerIcon = (provider) =>
  provider === "openai-codex"
    ? icon("codex")
    : el(
        "span",
        "provider-initial",
        provider?.slice(0, 1).toUpperCase() || "?",
      );
export function selectedModelControls(agent, status) {
  const selection = agent?.head.configuration.model || {
    provider: status?.provider,
    modelId: status?.modelId,
  };
  const entry = status?.models?.find(
    (model) =>
      model.provider === selection.provider &&
      model.modelId === selection.modelId,
  );
  return { selection, entry };
}
export function traitsLabel(selection, entry) {
  const effort =
    (entry?.thinkingLevels.length || 0) > 1
      ? labels[selection.thinkingLevel || "minimal"]
      : "";
  return effort
    ? `${effort}${selection.serviceTier === "priority" ? " Fast" : ""}`
    : labels[selection.serviceTier || "default"];
}
export function createChatControls({ host, onChange, report, onOpenModels }) {
  host.classList.add("composer-controls");
  let current,
    busy = false,
    generation = 0,
    openPopup,
    activeTrigger,
    selectedProvider;
  let favorites = new Set();
  try {
    const saved = JSON.parse(
      localStorage.getItem("agentspace.model-favorites") || "[]",
    );
    if (Array.isArray(saved))
      favorites = new Set(
        saved
          .filter((key) => typeof key === "string" && key.length < 500)
          .slice(0, 500),
      );
  } catch {
    /* Favorites remain usable without browser storage. */
  }
  const modelTrigger = button(
    "ui-control t3-composer-control model-control model-trigger",
    "Choose model",
    () => open("models"),
  );
  const traitsTrigger = button(
    "ui-control t3-composer-control traits-control",
    "Response options",
    () => open("traits"),
  );
  const modelPopup = el("div", "ui-popover t3-control-popup model-popover");
  const traitsPopup = el("div", "ui-popover t3-control-popup traits-popover");
  for (const [popup, trigger, id, role, label] of [
    [modelPopup, modelTrigger, "chat-model-popover", "dialog", "Choose model"],
    [
      traitsPopup,
      traitsTrigger,
      "chat-traits-popover",
      "menu",
      "Response options",
    ],
  ]) {
    popup.id = id;
    popup.setAttribute("popover", "auto");
    popup.setAttribute("role", role);
    popup.setAttribute("aria-label", label);
    trigger.setAttribute("aria-haspopup", role);
    trigger.setAttribute("aria-controls", id);
    trigger.setAttribute("aria-expanded", "false");
    popup.addEventListener("toggle", (event) => {
      trigger.setAttribute("aria-expanded", String(event.newState === "open"));
      if (event.newState === "closed" && openPopup === popup)
        openPopup = undefined;
    });
    popup.addEventListener("keydown", (event) => keydown(event, popup));
  }
  host.replaceChildren(modelTrigger, traitsTrigger, modelPopup, traitsPopup);
  function close(restoreFocus = false) {
    modelPopup.hidePopover();
    traitsPopup.hidePopover();
    openPopup = undefined;
    if (restoreFocus) activeTrigger?.focus();
  }
  function open(kind) {
    if (busy || current?.disabled || !current?.agent) return;
    const popup = kind === "models" ? modelPopup : traitsPopup;
    if (openPopup === popup) {
      close(true);
      return;
    }
    close();
    activeTrigger = kind === "models" ? modelTrigger : traitsTrigger;
    if (kind === "models") {
      selectedProvider = favorites.size
        ? "favorites"
        : selectedModelControls(current.agent, current.status).selection
            .provider;
      renderModels();
    } else renderTraits();
    const rect = activeTrigger.getBoundingClientRect();
    const width = kind === "models" ? 360 : 264;
    popup.style.left = `${Math.max(8, Math.min(rect.left, innerWidth - width - 8))}px`;
    popup.style.bottom = `${Math.max(8, innerHeight - rect.top + 4)}px`;
    popup.style.maxHeight = `${Math.max(100, Math.min(kind === "models" ? 346 : 600, rect.top - 12))}px`;
    popup.showPopover();
    openPopup = popup;
    (
      popup.querySelector("input") ||
      popup.querySelector('[aria-checked="true"]') ||
      popup.querySelector("button")
    )?.focus();
  }
  function keydown(event, popup) {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      close(true);
      return;
    }
    if (event.isComposing) return;
    const focused = document.activeElement;
    const buttons = [...popup.querySelectorAll("button")].filter(
      (node) => !node.disabled && !node.hidden && !node.closest("[hidden]"),
    );
    const rows = buttons.filter(
      (node) =>
        node.dataset.modelChoice ||
        node.getAttribute("role") === "menuitemradio",
    );
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      (buttons.includes(focused) ? focused : rows[0])?.click();
      return;
    }
    if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      const candidates = focused?.classList.contains("provider-button")
        ? buttons.filter((node) => node.classList.contains("provider-button"))
        : rows;
      const index = candidates.indexOf(focused);
      const next =
        event.key === "Home"
          ? 0
          : event.key === "End"
            ? candidates.length - 1
            : (index +
                (event.key === "ArrowDown" ? 1 : -1) +
                candidates.length) %
              candidates.length;
      candidates[next]?.focus();
      candidates[next]?.scrollIntoView({ block: "nearest" });
    }
    if (
      popup === modelPopup &&
      event.key === "ArrowLeft" &&
      focused?.tagName === "INPUT" &&
      focused.selectionStart === 0
    ) {
      event.preventDefault();
      modelPopup
        .querySelector(".provider-button[aria-pressed='true']")
        ?.focus();
    }
    if (
      popup === modelPopup &&
      event.key === "ArrowRight" &&
      focused?.classList.contains("provider-button")
    ) {
      event.preventDefault();
      modelPopup.querySelector("input")?.focus();
    }
  }
  window.addEventListener("resize", () => close());
  async function save(model) {
    if (busy || !current || current.disabled) return;
    const context = current,
      version = generation;
    busy = true;
    close();
    render();
    try {
      await onChange({
        tenantId: context.tenantId,
        agent: context.agent,
        model,
      });
    } catch (error) {
      if (version === generation) report(error);
    } finally {
      busy = false;
      render();
      if (version === generation) activeTrigger?.focus();
    }
  }
  function renderModels(query = "") {
    modelPopup.style.height = "";
    const { selection, entry } = selectedModelControls(
      current.agent,
      current.status,
    );
    const models = current.status?.models || [];
    const rail = el("div", "model-provider-rail");
    rail.setAttribute("role", "toolbar");
    rail.setAttribute("aria-label", "Providers");
    rail.setAttribute("aria-orientation", "vertical");
    for (const provider of [
      "favorites",
      ...new Set(models.map((model) => model.provider)),
    ]) {
      const item = button(
        "provider-button",
        provider === "favorites" ? "Favorites" : providerLabel(provider),
        () => {
          selectedProvider = provider;
          renderModels();
          modelPopup.querySelector("input")?.focus();
        },
      );
      item.setAttribute("aria-pressed", String(selectedProvider === provider));
      item.append(
        provider === "favorites" ? icon("star") : providerIcon(provider),
      );
      rail.append(item);
      if (provider === "favorites") rail.append(el("div", "provider-divider"));
    }
    const main = el("div", "model-picker-main"),
      searchWrap = el("div", "model-search-wrap"),
      searchLine = el("div", "model-search-line");
    const search = el("input", "model-search");
    search.type = "search";
    search.value = query;
    search.placeholder = "Search models...";
    search.setAttribute("aria-label", "Search models");
    searchLine.append(icon("search"), search);
    searchWrap.append(searchLine);
    const list = el("div", "model-options");
    list.setAttribute("aria-label", "Models");
    function rows() {
      const term = search.value.trim().toLowerCase();
      if (term && !modelPopup.style.height) {
        const height = modelPopup.getBoundingClientRect().height;
        if (height > 0) modelPopup.style.height = `${height}px`;
      } else if (!term) modelPopup.style.height = "";
      list.replaceChildren();
      const filtered = models.filter((model) =>
        term
          ? `${model.name} ${model.modelId} ${model.provider}`
              .toLowerCase()
              .includes(term)
          : selectedProvider === "favorites"
            ? favorites.has(modelKey(model))
            : model.provider === selectedProvider,
      );
      filtered.sort(
        (a, b) =>
          Number(favorites.has(modelKey(b))) -
          Number(favorites.has(modelKey(a))),
      );
      for (const model of filtered) {
        const selected = modelKey(model) === modelKey(selection),
          favorite = favorites.has(modelKey(model));
        const row = el("div", "model-row");
        row.dataset.selected = String(selected);
        const choose = button("model-option", model.name, () => {
          if (selected) {
            close(true);
            return;
          }
          void save({
            provider: model.provider,
            modelId: model.modelId,
            ...(model.thinkingLevels.includes(selection.thinkingLevel)
              ? { thinkingLevel: selection.thinkingLevel }
              : {}),
            ...(model.serviceTiers.includes(selection.serviceTier)
              ? { serviceTier: selection.serviceTier }
              : {}),
          });
        });
        choose.dataset.modelChoice = "true";
        choose.setAttribute("aria-pressed", String(selected));
        const text = el("span", "model-row-text");
        text.append(el("span", "model-row-name", model.name));
        if (term || selectedProvider === "favorites") {
          const provider = el("span", "model-row-provider");
          provider.append(
            providerIcon(model.provider),
            el("span", "", providerLabel(model.provider)),
          );
          text.append(provider);
        }
        choose.append(text);
        if (selected) choose.append(icon("check"));
        const star = button(
          "model-favorite",
          favorite ? "Remove from favorites" : "Add to favorites",
          (event) => {
            event.stopPropagation();
            const key = modelKey(model);
            if (favorites.has(key)) favorites.delete(key);
            else favorites.add(key);
            try {
              localStorage.setItem(
                "agentspace.model-favorites",
                JSON.stringify([...favorites]),
              );
            } catch {
              /* In-memory favorites still work. */
            }
            rows();
            const replacement = [...list.querySelectorAll("button")].find(
              (node) => node.dataset.favoriteKey === key,
            );
            (replacement || search).focus();
          },
        );
        star.dataset.favoriteKey = modelKey(model);
        star.setAttribute("aria-pressed", String(favorite));
        star.append(icon("star"));
        row.append(choose, star);
        list.append(row);
      }
      if (!filtered.length)
        list.append(
          el(
            "p",
            "model-empty",
            search.value.trim()
              ? "No models match your search."
              : "No models are connected yet.",
          ),
        );
    }
    search.addEventListener("input", rows);
    rows();
    main.append(searchWrap, list);
    // CHAT-04: explain an unavailable model and link to where it is fixed.
    if (!entry || !current.status?.models?.length) {
      const notice = el(
        "p",
        "model-notice",
        !entry && selection.modelId
          ? `${selection.modelId} isn't connected. Choose another model, or connect its provider.`
          : "Connect a model provider so your bunnies can reply.",
      );
      main.append(notice);
      if (onOpenModels)
        main.append(
          button("ui-control model-notice-action", "Open Models", () => {
            close();
            onOpenModels();
          }),
        );
    }
    modelPopup.replaceChildren(rail, main);
  }
  function renderTraits() {
    traitsPopup.replaceChildren();
    const { selection, entry } = selectedModelControls(
      current.agent,
      current.status,
    );
    for (const [key, title, values, fallback] of [
      ["thinkingLevel", "Effort", entry?.thinkingLevels || [], "minimal"],
      ["serviceTier", "Speed", entry?.serviceTiers || [], "default"],
    ]) {
      if (values.length < 2) continue;
      const group = el("div", "traits-group");
      group.setAttribute("role", "group");
      group.setAttribute("aria-label", title);
      group.append(el("div", "traits-heading", title));
      for (const value of values) {
        const selected = (selection[key] || fallback) === value;
        const item = button("ui-menu-item trait-option", labels[value], () => {
          if (selected) close(true);
          else void save({ ...selection, [key]: value });
        });
        item.setAttribute("role", "menuitemradio");
        item.setAttribute("aria-checked", String(selected));
        const line = el("span", "trait-option-label", labels[value]);
        if (value === fallback)
          line.append(el("span", "trait-default", "Default"));
        item.append(line);
        if (key === "serviceTier")
          item.append(
            el(
              "span",
              "trait-description",
              value === "priority"
                ? "Priority service. Availability and additional usage depend on your plan."
                : "Standard response speed.",
            ),
          );
        group.append(item);
      }
      traitsPopup.append(group);
    }
  }
  function render() {
    if (!current) return;
    const { selection, entry } = selectedModelControls(
      current.agent,
      current.status,
    );
    const unavailable = !entry && Boolean(selection.modelId);
    const modelName = entry?.name || selection.modelId || "Choose model";
    modelTrigger.replaceChildren(
      providerIcon(selection.provider),
      el("span", "control-label", modelName),
      ...(unavailable ? [el("span", "model-state-dot")] : []),
      icon("chevron"),
    );
    modelTrigger.dataset.state = unavailable ? "unavailable" : "ready";
    modelTrigger.title = unavailable
      ? `${modelName} isn't connected. Choose another model or connect its provider in Models.`
      : `${modelName} · Applies to this bunny’s next turns`;
    modelTrigger.setAttribute(
      "aria-label",
      `Choose model: ${modelName}${unavailable ? ", not connected" : ""}`,
    );
    const label = traitsLabel(selection, entry);
    traitsTrigger.replaceChildren(
      icon("brain"),
      el("span", "control-label", label),
      icon("chevron"),
    );
    traitsTrigger.setAttribute("aria-label", label);
    traitsTrigger.title = `${label} · Response options for this bunny’s next turns`;
    traitsTrigger.hidden =
      (entry?.thinkingLevels.length || 0) < 2 &&
      (entry?.serviceTiers.length || 0) < 2;
    for (const trigger of [modelTrigger, traitsTrigger])
      trigger.disabled = busy || current.disabled || !current.agent;
  }
  return {
    update(value) {
      if (
        current?.tenantId !== value.tenantId ||
        current?.agent?.id !== value.agent?.id ||
        current?.agent?.head.id !== value.agent?.head.id ||
        current?.disabled !== value.disabled
      ) {
        generation++;
        close();
      }
      current = value;
      render();
    },
  };
}
